<template>
  <v-img :src="imageSrc" v-bind="$attrs" />
</template>

<script>
import { computed } from 'vue'
import { useTheme } from 'vuetify'

// Import all illustrations statically
import welcomeDark from '@/assets/img/illustrations/welcome-dark.svg'
import welcomeLight from '@/assets/img/illustrations/welcome-light.svg'
import aboutUsDark from '@/assets/img/illustrations/about-us-dark.svg'
import aboutUsLight from '@/assets/img/illustrations/about-us-light.svg'
import errorDark from '@/assets/img/illustrations/error-dark.svg'
import errorLight from '@/assets/img/illustrations/error-light.svg'
import feedbackDark from '@/assets/img/illustrations/feedback-dark.svg'
import feedbackLight from '@/assets/img/illustrations/feedback-light.svg'
import getHelpDark from '@/assets/img/illustrations/get-help-dark.svg'
import getHelpLight from '@/assets/img/illustrations/get-help-light.svg'
import noBookmarksDark from '@/assets/img/illustrations/no-bookmarks-dark.svg'
import noBookmarksLight from '@/assets/img/illustrations/no-bookmarks-light.svg'
import noCollectionsDark from '@/assets/img/illustrations/no-collections-dark.svg'
import noCollectionsLight from '@/assets/img/illustrations/no-collections-light.svg'
import noDeletedDark from '@/assets/img/illustrations/no-deleted-dark.svg'
import noDeletedLight from '@/assets/img/illustrations/no-deleted-light.svg'
import offboardingDark from '@/assets/img/illustrations/offboarding-dark.svg'
import offboardingLight from '@/assets/img/illustrations/offboarding-light.svg'

// Create mapping objects for illustrations
const ILLUSTRATIONS = {
  welcome: {
    dark: welcomeDark,
    light: welcomeLight,
  },
  'about-us': {
    dark: aboutUsDark,
    light: aboutUsLight,
  },
  error: {
    dark: errorDark,
    light: errorLight,
  },
  feedback: {
    dark: feedbackDark,
    light: feedbackLight,
  },
  'get-help': {
    dark: getHelpDark,
    light: getHelpLight,
  },
  'no-bookmarks': {
    dark: noBookmarksDark,
    light: noBookmarksLight,
  },
  'no-collections': {
    dark: noCollectionsDark,
    light: noCollectionsLight,
  },
  'no-deleted': {
    dark: noDeletedDark,
    light: noDeletedLight,
  },
  offboarding: {
    dark: offboardingDark,
    light: offboardingLight,
  },
}

export default {
  props: {
    name: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    // Get theme instance
    const theme = useTheme()

    // Computed property to check if dark theme is active
    const isDark = computed(() => theme.global.current.value.dark)

    // Computed property to get the appropriate image source
    const imageSrc = computed(() => {
      const themeType = isDark.value ? 'dark' : 'light'

      // Use the mapping object instead of dynamic require
      if (ILLUSTRATIONS[props.name]) {
        return ILLUSTRATIONS[props.name][themeType]
      }

      // Fallback to error illustration if not found
      return ILLUSTRATIONS.error[themeType]
    })

    return {
      imageSrc
    }
  }
}
</script>
